import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subscription } from 'rxjs';
import { TranslationService } from 'src/app/modules/i18n/translation.service';
import { HospitalService } from '../../_services';
import { Router } from '@angular/router';
import { HotToastService } from '@ngneat/hot-toast';
declare const fabric: any;



@Component({
  selector: 'app-congrats-cards-edit',
  templateUrl: './congrats-cards-edit.component.html',
  styleUrls: ['./congrats-cards-edit.component.scss']
})
export class CongratsCardsEditComponent implements OnInit, OnDestroy {
  language: any;
  isLoading$: Observable<boolean>;
  private subscriptions: Subscription[] = []; 

  canvas: any;
  text: any;
  Name: string = '';
  selectedColor = "Black";
  AnotherColor: boolean = false;
  AnotherColortxt = '';
  @ViewChild('myCanvas') canvasRef: ElementRef;
  ImagePath: string;
  colors = [{Value:'#405076' , Name :'Teal Blue / أزرق غامق'}, 
  {Value:'#3672B9' , Name :'Steel Blue / أزرق فولاذي'}, 
  {Value:'#3ABBE8' , Name :'Dodger Blue / أزرق سماوي'}, 
  {Value:'#A2215D' , Name :'Deep Cerise / كريزي غامق'},
  {Value:'#A36861' , Name :'Copper /  نحاسي'},
  {Value:'#FFFF' , Name :'White /  ابيض'}];



  constructor(private HospitalService: HospitalService, private toast: HotToastService,
    public dialog: MatDialog, private translationService: TranslationService, private router: Router) { }

  ngOnInit(): void {
    this.language = this.translationService.getSelectedLanguage();
    this.canvas = new fabric.Canvas('canvas');

    // Set the canvas dimensions based on the screen size
    const WindowWidth = window.innerWidth;
    if (sessionStorage.getItem("ImagePath")) {
      this.ImagePath = sessionStorage.getItem("ImagePath");
    }
    else {
      if (this.language == "ar") {
        this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
      }
      else {
        this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
      }
      this.router.navigate(['/congrats-cards']);

    }

    fabric.Image.fromURL(this.ImagePath, (img) => {
   
      if (WindowWidth < 576) {
        this.canvas.setDimensions({
          width: 350,
          height: 350
        });
        img.scaleToWidth(this.canvas.width);
        img.scaleToHeight(this.canvas.height);
      }
      else if (WindowWidth >= 576 && WindowWidth < 768) {
        this.canvas.setDimensions({
          width: 450,
          height: 450
        });
        img.scaleToWidth(this.canvas.width);
        img.scaleToHeight(this.canvas.height);
      }
      else if (WindowWidth >= 768 && WindowWidth < 992) {
        this.canvas.setDimensions({
          width: 650,
          height: 650
        });
        img.scaleToWidth(this.canvas.width);
        img.scaleToHeight(this.canvas.height);
      }
      else
      {
        this.canvas.setDimensions({
          width: 800,
          height: 800
        });
        img.scaleToWidth(this.canvas.width);
        img.scaleToHeight(this.canvas.height);
      }
      // if (WindowWidth > 991) {

      //   this.canvas.setDimensions({
      //     width: 800,
      //     height: 800
      //   });

      //   // Scale the image to the new size
      //   img.scaleToWidth(800);
      //   img.scaleToHeight(800);

      // }
      // else {

      //   this.canvas.setDimensions({
      //     width: 430,
      //     height: 430
      //   });
      //   // Scale the image to the new size
      //   img.scaleToWidth(430);
      //   img.scaleToHeight(430);
      // }

      this.canvas.setBackgroundImage(img, this.canvas.renderAll.bind(this.canvas));
    });

    this.text = new fabric.Text('', {
      left: 100,
      top: 100,
      fontSize: 36,
      fontFamily: 'Arial',
      fontWeight: 'Bold',
      fill: 'Black',
      selectable: true,
      editable: true,
      draggable: true,
    });

    this.canvas.add(this.text);
    this.canvas.on('object:moving', (e) => {
      const obj = e.target;
      if (obj.type === 'text') {
        obj.setCoords();
        const textPos = obj.getBoundingRect();
        const imgPos = this.canvas.backgroundImage.getBoundingRect();
        if (textPos.left < imgPos.left || textPos.top < imgPos.top ||
          textPos.left + textPos.width > imgPos.left + imgPos.width ||
          textPos.top + textPos.height > imgPos.top + imgPos.height) {
          obj.left = obj.lastLeft;
          obj.top = obj.lastTop;
          obj.setCoords();
        } else {
          obj.lastLeft = obj.left;
          obj.lastTop = obj.top;
        }
      }
    });
    this.isLoading$ = this.HospitalService.isLoading$;
  }

  
  UpdateText() {
    if (this.selectedColor == '') {
      this.AnotherColor = true;
      this.AnotherColortxt == '' ? this.text.set('fill', "Black") : this.text.set('fill', this.AnotherColortxt);
    }
    else {
      this.AnotherColor = false;
      this.text.set('fill', this.selectedColor);
    }
    this.text.set('text', this.Name);
    this.canvas.renderAll();
  }
  SaveImage() {
    // Export the canvas to a data URL
    const dataURL = this.canvas.toDataURL();

    // Convert the data URL to a Blob object
    const blob = this.dataURLtoBlob(dataURL);

    // Create a link element to download the image
    const link = document.createElement('a');
    link.download = 'Congrat-Card.png';
    link.href = window.URL.createObjectURL(blob);

    // Click the link to download the image
    link.click();
  }
  dataURLtoBlob(dataURL: string): Blob {
    const arr = dataURL.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }
  onNoClick(): void {
    this.router.navigate(['/congrats-cards']);
  }
  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }
}
